import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { BookingDetails } from 'app/typings/core/extranet/bookings/booking';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useBooking(hotelId: number, bookingCode?: string) {
  const key = useMemo(() => {
    return [CORE_QUERY_KEYS.booking, hotelId, bookingCode];
  }, [hotelId, bookingCode]);

  return useQuery({
    queryKey: key,
    queryFn: bookingCode
      ? () =>
          apiRequest({
            path: ENDPOINTS.getBooking,
            params: { hotelId: hotelId.toString(), bookingCode },
          }) as Promise<{ booking: BookingDetails }>
      : () => Promise.resolve(null),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId && !!bookingCode,
  });
}
